(() => {
  'use strict';
  const parisToday = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
    return ['year', 'month', 'day'].map(key => parts.find(part => part.type === key).value).join('-');
  };
  const leadDays = settings => Math.max(5, Math.ceil(Number(settings.leadDays) || 5));
  const minimum = settings => {
    const day = new Date(parisToday() + 'T12:00:00Z');
    day.setUTCDate(day.getUTCDate() + leadDays(settings));
    return day.toISOString().slice(0, 10);
  };
  const allowed = (value, settings) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const day = new Date(value + 'T12:00:00Z');
    if (!Number.isFinite(day.getTime()) || day.toISOString().slice(0, 10) !== value || value < minimum(settings)) return false;
    const closed = String(settings.closedWeekdays || '').split(',').map(s => s.trim()).filter(Boolean).map(Number);
    const blocked = String(settings.blockedDates || '').split(',').map(s => s.trim());
    return !closed.includes(day.getUTCDay()) && !blocked.includes(value);
  };
  window.PinkPickup = {parisToday, leadDays, minimum, allowed};
})();
